/** @jsxRuntime automatic */
import { forwardRef, type LabelHTMLAttributes } from "react";
import { cn } from "./utils";

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn("text-label font-medium text-foreground", className)}
      {...props}
    />
  ),
);
Label.displayName = "Label";
